/*
  Single source of truth for the brand roster and per-brand assets.

  Adding a brand = one entry here (plus its Asana project in server.py's
  project_names - keep the two rosters in sync until the planned
  /api/brands endpoint serves both sides from one place).

  Omitting a property hides that feature for the brand rather than
  borrowing another brand's asset: no `overlay` = no vehicle-overlay
  button, no `guidePDF` = no guide button. Stellantis ships without an
  overlay or guide until the art team delivers them.

  `platesProgram: true` routes the brand's dealers through the
  phototype chooser (dealership backgrounds vs. license plates/frames)
  after ID validation; brands without it go straight to the photo flow.
*/
const brands = [
  {
    name: 'GM',
    platesProgram: true,
    logo: '/components/Brand-logos/App_NoShadow_600_GM_Logos.png',
    overlay: '/components/App_VehicleOverlay_2_2025_Chevrolet_Silverado_LD.png',
    groundOverlay: '/components/ground-overlays/App_VehicleOverlay_2_GM_Ground.png',
    guidePDF: '/DP-Guides/PHOTO_GUIDE_GM.pdf',
  },
  {
    name: 'Ford',
    platesProgram: true,
    logo: '/components/Brand-logos/App_NoShadow_600_FORD_LINCOLN_Logo.png',
    overlay: '/components/App_VehicleOverlay_2_2025_Ford_Explorer.png',
    groundOverlay: '/components/ground-overlays/App_VehicleOverlay_2_Ford_Lincoln_Ground.png',
    guidePDF: '/DP-Guides/PHOTO_GUIDE_FORD.pdf',
  },
  {
    name: 'Genesis',
    logo: '/components/Brand-logos/App_NoShadow_600_GENESIS_Logo.png',
    overlay: '/components/App_VehicleOverlay_2_2026_Genesis_GV70.png',
    groundOverlay: '/components/ground-overlays/App_VehicleOverlay_2_Genesis_Ground.png',
    guidePDF: '/DP-Guides/PHOTO_GUIDE_GENESIS.pdf',
  },
  {
    name: 'Hyundai',
    logo: '/components/Brand-logos/App_NoShadow_600_HYUNDAI_Logo.png',
    overlay: '/components/App_VehicleOverlay_2_2025_Hyundai_Palisade.png',
    groundOverlay: '/components/ground-overlays/App_VehicleOverlay_2_Hyundai_Ground.png',
    guidePDF: '/DP-Guides/PHOTO_GUIDE_HYUNDAI.pdf',
  },
  {
    name: 'Infiniti',
    logo: '/components/Brand-logos/App_NoShadow_600_INFINITI_Logo.png',
    overlay: '/components/App_VehicleOverlay_2_2025_Infiniti_QX60.png',
    groundOverlay: '/components/ground-overlays/App_VehicleOverlay_2_Infiniti_Ground.png',
    guidePDF: '/DP-Guides/PHOTO_GUIDE_INFINITI.pdf',
  },
  {
    name: 'Kia',
    logo: '/components/Brand-logos/App_NoShadow_600_KIA_Logo.png',
    overlay: '/components/App_VehicleOverlay_2_2025_Kia_Telluride.png',
    groundOverlay: '/components/ground-overlays/App_VehicleOverlay_2_Kia_Ground.png',
    guidePDF: '/DP-Guides/PHOTO_GUIDE_KIA.pdf',
  },
  {
    name: 'Nissan',
    logo: '/components/Brand-logos/App_NoShadow_600_NISSAN_Logo.png',
    overlay: '/components/App_VehicleOverlay_2_2026_Nissan_Pathfinder.png',
    groundOverlay: '/components/ground-overlays/App_VehicleOverlay_2_Nissan_Ground.png',
    guidePDF: '/DP-Guides/PHOTO_GUIDE_NISSAN.pdf',
  },
  {
    name: 'Stellantis',
    logo: '/components/Brand-logos/App_NoShadow_600_STLA_Logo.png',
    // overlay + guidePDF on order from the art team
    groundOverlay: '/components/ground-overlays/App_VehicleOverlay_2_STLA_Ground.png',
  },
];

export default brands;

export function getBrand(name) {
  return brands.find((b) => b.name === name);
}
